import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { getReport } from "../../../actions/admin-actions"
import { Row, Col } from "react-flexbox-grid";
import { FaDownload } from "react-icons/fa";
import Dropdown from "../../../components/Dropdown";
import styles from "../styles/dashboard.module.scss"
import * as getVariables  from '../../../helpers/globalVariables.js'
import { Bar } from 'react-chartjs-2';
const uuidv4 = require('uuid/v4')

class UsersInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      chartType: 'new',
      typeOptions: this.typeOptions,
      typeValue: this.typeOptions[0], 
      monthOptions: getVariables.months(),
      monthValue: {},
      yearsOptions: getVariables.years(2020),
      yearValue: getVariables.years(2020)[0],
      dropdownKey: uuidv4(),
      sessionDuration: [],
      loginsUsers: [],
      newUsers: [],
      chart: {},
      yLabel: '',
      reportIsEmpty: false,
      lastSortKey: '',
      CSV: []
    };
  }

  typeOptions = [
    // {value: 'new', label: 'New Users'},
    // {value: 'login', label: 'Logins Per Users'},
    {value: 'login', label: 'New Users and Logins'},
    {value: 'duration', label: 'Avg. Session Duration'}
  ];

  componentDidMount() {
    this.getCurrentMonth();
  }
  
  componentDidUpdate(prevProps) {
    if (!this.props.getReportSuccess && prevProps.getReportSuccess) {
      const reports = this.props.reportInfo;
      if (reports.sessionDuration && reports.loginsUsers && reports.newUsers )
        this.setState({
          sessionDuration: reports.sessionDuration,
          loginsUsers: reports.loginsUsers,
          newUsers: reports.newUsers,
          reportIsEmpty: false
        },
        () => this.fillChart()
        );
      else 
        this.setState({
          reportIsEmpty: true
        })
    }
  }

  getCurrentMonth = () => {
    let today = new Date();
    this.setState({ monthValue: this.state.monthOptions[today.getMonth()]},
    () => this.getNewReport(today.getFullYear(), this.state.monthOptions[today.getMonth()].value)
    );
  }

  fillChart = (type = 'users') => {
    let arr = [];
    let data2 = {
      labels: [],
      datasets: [{
          label: '',
          data: [],
          backgroundColor: [],
          borderColor: [],
          borderWidth: 1
      }]
    }

    let data = {
      labels: [],
      datasets: [{
          label: '',
          data: [],
          backgroundColor: [],
          borderColor: [],
          borderWidth: 1
      },
      {
        label: '',
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1
      }]
    }

  
    this.state.loginsUsers.forEach((day, i) => {
      if (type === 'users'){
        data.labels.push(i + 1);
        data.datasets[0].label = '# of Logins';
        data.datasets[0].data.push(day);
        data.datasets[0].backgroundColor.push('rgba(104, 210, 223, 0.5)');
        data.datasets[0].borderColor.push('rgba(104, 210, 223, 1)');

        data.datasets[1].label = '# of New Users';
        data.datasets[1].data.push(this.state.newUsers[i]);
        data.datasets[1].backgroundColor.push('rgba(181, 106, 251, 0.5)');
        data.datasets[1].borderColor.push('rgba(181, 106, 251, 1)');

        arr.push({
          date: i + 1,
          logins: day,
          newUsers: this.state.newUsers[i]
        })
      }
      else {
        data2.labels.push(i + 1);
        data2.datasets[0].label = 'Avg. Session Duration';
        //data2.datasets[0].data.push(this.state.sessionDuration[i]);
        data2.datasets[0].backgroundColor.push('rgba(104, 210, 223, 0.5)');
        data2.datasets[0].borderColor.push('rgba(104, 210, 223, 1)');

        let day = this.state.sessionDuration[i].users;
        let minutes = 0;
        let users = 0;
        for (let user in day) {
          let sum = 0;
          day[user].forEach(login => {
            sum = login.minutes + sum;
            users++;
            arr.push({
              date: i + 1,
              email: user,
              login: login.login,
              last: login.lastRequest,
              minutes: login.minutes
            })
          });
          minutes = minutes + sum;
        }
        data2.datasets[0].data.push( (minutes/users).toFixed(1) );
      }
    });

    this.setState({
      chart: type === 'users' ? data : data2,
      yLabel: type === 'users' ? 'Users' : 'Minutes',
      CSV: arr
    })
  }

  download = () => {
    const userList = this.state.CSV;
    let csvContent;

    if (this.state.typeValue.value === 'duration'){
      csvContent = "data:text/csv;charset=utf-8,Day,Email,Login,Last Activity, Minutes\n" +
        userList.map(e => e.date + ',' + e.email + ',' +  e.login + ',' + e.last + ',' + e.minutes).join("\n");
    }
    else {
      csvContent = "data:text/csv;charset=utf-8,Day, # of Logins, # of New Users\n" +
        userList.map(e => e.date + ',' + e.logins + ',' +  e.newUsers).join("\n");
    }
    let type = this.state.typeValue.value === 'duration' ? '-session-duration-per-user' : '-users'
    let title = this.state.lastSortKey + type + '.csv'
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", title);
    document.body.appendChild(link); // Required for FF
    link.click(); // This will download the data file named "my_data.csv"
  }

  getNewReport = (year, month) => {
    let sortKey = year + '-' + month;
    if (this.state.lastSortKey !== sortKey) {
      let data = {
        payload: {
          email: 'report',
          sortKey: sortKey
        }
      }
      this.props.getReport(data);
      this.setState({ 
        lastSortKey: sortKey,
        typeValue: this.typeOptions[0]
      })
    }
  }

  onChangeTypeOption = (event) => {
    const { value } = event;
    this.setState({typeValue: event});
    let val = value !== 'duration' ? 'users' : 'duration'
    this.fillChart(val)
  }

  onChangeMonthOption = (event) => {
    this.setState({monthValue: event});
    const { value } = event;
    this.getNewReport(this.state.yearValue.value, value);
  }

  onChangeYearOption = (event) => {
    this.setState({yearValue: event});
    const { value } = event;
    this.getNewReport(value, this.state.monthValue.value);
  }

  render() {
    return (
      <div>
        <Row>
          <Col xs={3}>
            <Dropdown
              dropdownKey={this.state.dropdownKey}
              label="Chart Type"
              options={this.state.typeOptions}
              onChange={this.onChangeTypeOption}
              defaultValue={this.state.typeValue}
              value={this.state.typeValue}
            />
          </Col>
          <Col xs={3}>
            <Dropdown
            dropdownKey={this.state.dropdownKey}
            label="Month"
            options={this.state.monthOptions}
            onChange={this.onChangeMonthOption}
            defaultValue={this.state.monthValue}
            value={this.state.monthValue}
          />
          </Col>
          <Col xs={3}>
            <Dropdown
              dropdownKey={this.state.dropdownKey}
              label="Year"
              options={this.state.yearsOptions}
              onChange={this.onChangeYearOption}
              defaultValue={this.state.yearValue}
              value={this.state.yearValue}
            />
          </Col>
          <Col xs={3} style={{display: 'flex'}}>
            { !this.state.reportIsEmpty &&
              <button 
                title={"Download Report"} 
                className={styles.___csv2} 
                value="Download Report"
                onClick={this.download}
              >
                <FaDownload size={25} color={'#68d2df'}/>
                <span className={styles.__txt_button}>Download Report</span>
              </button> 
            }
          </Col>
        </Row>
        { !this.state.reportIsEmpty &&
        <div style={{paddingTop:10}}>
          <Bar
            data={this.state.chart}
            width={100}
            height={450}
            options={{
              maintainAspectRatio: false,
              scales: {
                  yAxes: [{
                    scaleLabel: {
                      display: true,
                      labelString: this.state.yLabel
                    }
                  }],
                  xAxes: [{
                    scaleLabel: {
                      display: true,
                      labelString: 'Days'
                    }
                  }],
                } 
            }}
          />
        </div>
        }
        { this.state.reportIsEmpty &&
        <div className={styles.__empty}>
          <section>
            <img
              src={"/images/emptyCalendar.png"}
              alt="Empty Calendar"
              style={{width: 340}}
            />
            <div className={styles.__emptyMessage}>
              <h2>The monthly report is empty</h2>
            </div>
          </section>
        </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    reportInfo: state.adminReducer.reportData,
    getReportSuccess: state.adminReducer.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getReport: (data) => dispatch(getReport(data))
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  UsersInformation
);
